export default __webpack_public_path__ + "static/media/remati-lq.76b077e0.mp4";